import { Component, ChangeDetectionStrategy, computed, input, signal } from '@angular/core';

import { TipoEnlace } from '../../models/notificacion-institucional.model';

const PLACEHOLDER ='Tu mensaje aparecerá acá';
const PLACEHOLDER_TITULO = 'Tu título aparecerá acá';
const PLACEHOLDER_BOTON = 'Ver más';

type TabPreview = 'push' | 'popup';

// Previsualización con tabs Push/Pop-up (un solo teléfono genérico, sin
// distinción Android/iOS) — fiel al artifact de diseño del usuario, ver
// docs/specs/abmc-notificacion-institucional.md §3.3/§9.8.
//
// `titulo` es un campo propio del formulario (corrección post-implementación
// #7), separado de "Nombre interno" — que quedó solo de uso interno.
@Component({
  selector: 'app-notificacion-preview',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './notificacion-preview.component.html',
  styleUrl: './notificacion-preview.component.scss'
})
export class NotificacionPreviewComponent {
  readonly titulo = input<string>('');
  readonly mensajeCorto = input<string>('');
  readonly mensajeAmpliado = input<string>('');
  // null = sin enlace (el pop-up no muestra botón).
  readonly textoBotonEnlace = input<string | null>(null);

  readonly tipoEnlace = input<TipoEnlace>('SIN_ENLACE');
  readonly urlEnlace = input<string>('');
  // Nombre (no id) de la sección elegida; vacío si no hay selección.
  readonly seccionNombre = input<string>('');

  readonly tab = signal<TabPreview>('push');
  readonly destinoAbierto = signal(false);
  readonly textoBoton = computed(() => this.textoBotonEnlace()?.trim() || PLACEHOLDER_BOTON);
  readonly iconoBoton = computed(() => (this.tipoEnlace() === 'EXTERNO' ? '↗' : '→'));
  readonly urlDestino = computed(() => this.urlEnlace().trim());
  readonly nombreSeccion = computed(() => this.seccionNombre().trim());
  // Sin URL / sección el botón se muestra pero no simula nada.
  readonly hayDestino = computed(() => {
    const tipo = this.tipoEnlace();
    if (tipo === 'EXTERNO') return !!this.urlDestino();
    if (tipo === 'SECCION_APP') return !!this.nombreSeccion();
    return false;
  });
  readonly mostrarDestino = computed(() => this.destinoAbierto() && this.hayDestino());

  // Solo simulación: nunca navega ni abre la URL real.
  abrirDestino(): void {
    if (this.hayDestino()) this.destinoAbierto.set(true);
  }

  cambiarTab(tab: TabPreview): void {
    this.destinoAbierto.set(false);
    this.tab.set(tab);
  }

  readonly textoTitulo = computed(() => this.titulo().trim() || PLACEHOLDER_TITULO);
  readonly textoCorto = computed(() => this.mensajeCorto().trim() || PLACEHOLDER);
  readonly textoAmpliado = computed(() => this.mensajeAmpliado().trim() || PLACEHOLDER);
  readonly esVacioTitulo = computed(() => !this.titulo().trim());
  readonly esVacioCorto = computed(() => !this.mensajeCorto().trim());
  readonly esVacioAmpliado = computed(() => !this.mensajeAmpliado().trim());
}
